import { useRef } from "react"

export const useDebounce = ({ fn, delay }: { fn: Function; delay: number }) => {
  // eslint-disable-next-line no-undef
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  function debaunceFn(...params: any[]) {
    clearTimeout(timeoutRef.current!)
    timeoutRef.current = setTimeout(() => {
      fn(...params)
    }, delay)
  }

  return debaunceFn
}
